<template>
  <span>
    <div class="page-level-functions">
      <router-link to="/">
        <action-button
          variant="outline-success float-right ml-3"
          text="Regresar"
          i="fas fa-arrow-circle-left"/>
      </router-link>
    </div>
    <hr class="page-level-functions-separator" />
    <div class="sub-content-wrapper">
      <search-criteria-entry @searchClicked="callGetResult">
        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text input-icon">
                <em class="fas fa-lg fa-search"/>
              </span>
            </div>
            <input
              v-model="searchCriteria.filterText.model"
              type="text"
              class="form-control filter-input"
              :placeholder="searchCriteria.filterText.placeholder"
              :maxlength="searchCriteria.filterText.maxlength"
              @keyup.enter="callGetResult"
            />
          </div>
        </div>
      </search-criteria-entry>
      <div class="row mt-3">
        <custom-title-divider title="Información de las Aplicaciones" />
      </div>
      <div class="mx-n3">
        <result-not-found v-if="result.data.length === 0" />
        <div v-for="(row, index) in result.data" :key="`row-app-${index}`">
          <callout class="my-3" :has-toggle="false">
            <div class="row my-0">
              <div class="col-md-10">
                <div class="row mt-2">
                  <div class="col-md-1 d-flex align-items-center mr-n5">
                    <em class="fas fa-lg fa-globe align-middle row-icon" />
                  </div>
                  <div class="col-md-3">
                    <div class="color-secondary-6 font-16">Aplicación:</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.applicationName }}</div>
                  </div>
                  <div class="col-md-3">
                    <div class="color-secondary-6 font-16">Nombre a mostrar:</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.displayName }}</div>
                  </div>
                  <div class="col-md-5">
                    <div class="color-secondary-6 font-16">Descripción:</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.description }}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 d-flex justify-content-end align-items-center pr-5">
                <router-link :to="'/applications/' + row.applicationId">
                  <action-button
                    variant="outline-success enter-button mr-2"
                    text="Entrar"
                    i="fas fa-sign-in-alt"
                    min-width="100px"/>
                </router-link>
              </div>
            </div>
          </callout>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import SearchCriteriaEntry from '@/components/common/SearchCriteriaEntry'
import { getApplicationSearchResults } from '@/modules/applications/api'
import CustomTitleDivider from '@/components/common/CustomTitleDivider'
import ActionButton from '@/components/common/ActionButton'
import '@/mixins/vue-alerts'
import { mapGetters, mapActions } from 'vuex'
import { name as appsModuleName } from '@/modules/applications/store'
import Callout from '@/components/common/callout/View'
import ResultNotFound from '@/components/common/ResultNotFound'
import storeMixin from '@/mixins/storeGenerator';

const initialSearchState = () => ({
  filterText: {
    model: null,
    placeholder: 'Escriba Descripción o Nombre de Aplicación o Nombre a Mostrar',
    maxlength: 100,
  },
});

const initialResultState = () => ({
  data: [],
  pagination: {
    totalItemCount: 0,
    count: 15,
    pageCount: 0,
    currentPage: 1,
  },
});

export default {
  name: 'UserSearch',
  components: {
    SearchCriteriaEntry,
    CustomTitleDivider,
    ActionButton,
    Callout,
    ResultNotFound,
  },
  mixins: [storeMixin],
  data() {
    return {
      searchCriteria: { ...initialSearchState() },
      result: initialResultState(),
    }
  },
  computed: {
    ...mapGetters(appsModuleName, ['affectedApplicationData']),
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      if (from.name == 'home') {
        vm.shouldRecovery = false;
        vm.searchCriteria = initialSearchState();
        vm.result = initialResultState();
      } else vm.recoveryData();

      vm.callGetResult(vm.result.pagination.currentPage);
    });
  },
  async created() {
    if (this.affectedApplicationData) {
      const verb = this.getAction(this.affectedApplicationData.operation);
      this.Toast(
        'Aviso',
        'La aplicación fue ' + verb + ' exitosamente.',
        'success'
      )
      await this.setAffectedApplicationData(null)
    }
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    getAction(action) {
      switch (action) {
        case 'I':
          return 'creada'
        case 'U':
          return 'actualizada';
        default:
          return '???'; //ECG:No se que le hiciste al app! :P
      }
    },
    ...mapActions(appsModuleName, ['setAffectedApplicationData']),
    async callGetResult(pageNumber = 1) {
      const payload = {
        filterCriteria: this.searchCriteria.filterText.model,
        pageNumber,
        pageSize: this.result.pagination.count,
      }
      const { data } = await getApplicationSearchResults(payload)
      this.result = {
        ...this.result,
        data: data.data,
      }
    },
  },
}
</script>

<style scoped>
.enter-button {
  background-color: transparent;
  float: right;
}
.row-icon {
  color: #ff7058;
}
</style>
